var _a;
import addMinutes from 'date-fns/addMinutes';
import isDate from 'date-fns/isDate';
import { getTimezoneOffset } from 'date-fns-tz';
import { isDateAfterType, isDateBeforeType, isDateInterval, isDateRange } from 'react-day-picker';
export var defaultLocale = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.language) || 'en-GB';
export var isDateFnsLocale = function (value) {
    return typeof value === 'object' && !!value.code;
};
export var getLocaleCode = function (locale) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return isDateFnsLocale(locale) ? locale.code : locale || defaultLocale;
};
/**
 * Gets difference in minutes between local and the specified TZ. date-fns-tz returns
 * negative numbers for the western hemisphere, whereas for `Date.prototype.getTimezoneOffset`
 * this is the opposite.
 */
var getDiff = function (date, timezone) {
    return date.getTimezoneOffset() - getTimezoneOffset(timezone, date) / -60000;
};
/**
 * Shifts time value ahead of the date by the difference of the local time and given timezone
 */
export var createDateShiftedToTimezone = function (date, timezone) {
    return addMinutes(date, getDiff(date, timezone));
};
/**
 * Shifts time value behind of the date by the difference of the local time and given timezone
 */
export var createDateShiftedFromTimezone = function (date, timezone) {
    return addMinutes(date, getDiff(date, timezone) * -1);
};
/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return isDate(value);
}
/**
 * Adjusts given value(s) for timezone-aware date picker display
 */
export var createReactDayPickerValueForTimezone = function (value, timezone) {
    if (isDateType(value))
        return createDateShiftedToTimezone(value, timezone);
    if (Array.isArray(value))
        return value.map(function (matcher) {
            return createReactDayPickerValueForTimezone(matcher, timezone);
        });
    if (isDateRange(value))
        return {
            from: value.from ? createDateShiftedToTimezone(value.from, timezone) : undefined,
            to: value.to ? createDateShiftedToTimezone(value.to, timezone) : undefined,
        };
    if (isDateInterval(value))
        return {
            before: createDateShiftedToTimezone(value.before, timezone),
            after: createDateShiftedToTimezone(value.after, timezone),
        };
    if (isDateAfterType(value))
        return { after: createDateShiftedToTimezone(value.after, timezone) };
    if (isDateBeforeType(value))
        return { before: createDateShiftedToTimezone(value.before, timezone) };
    if (value instanceof Function)
        return function (date) { return value(createDateShiftedToTimezone(date, timezone)); };
    return value; // return boolean and date of week values as-is
};
//# sourceMappingURL=utils.js.map